import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import WinToken from "@/components/WinToken";
import AITrading from "@/components/AITrading";
import RegularIncome from "@/components/RegularIncome";
import CapitalProtection from "@/components/CapitalProtection";
import Ecosystem from "@/components/Ecosystem";
import Infrastructure from "@/components/Infrastructure";
import FutureModules from "@/components/FutureModules";
import Roadmap from "@/components/Roadmap";
import About from "@/components/About";
import Investors from "@/components/Investors";
import Referral from "@/components/Referral";
import DownloadCTA from "@/components/DownloadCTA";
import Footer from "@/components/Footer";
import { AuthProvider } from "@/auth/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import VerifyMagic from "@/pages/VerifyMagic";
import RequireAuth from "@/members/RequireAuth";
import MembersLayout from "@/members/MembersLayout";
import Overview from "@/members/Overview";
import Wallet from "@/members/Wallet";
import Token from "@/members/Token";
import Products from "@/members/Products";
import Rewards from "@/members/Rewards";
import Referrals from "@/members/Referrals";
import Profile from "@/members/Profile";

const Grain = () => (
  <div
    className="pointer-events-none fixed inset-0 z-[60] opacity-[0.05]"
    aria-hidden="true"
    style={{
      backgroundImage:
        "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
    }}
  />
);

const Landing = () => (
  <SmoothScroll>
    <div className="min-h-screen bg-[#08080A] text-white overflow-x-clip">
      <Grain />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <WinToken />
        <AITrading />
        <RegularIncome />
        <CapitalProtection />
        <Ecosystem />
        <Infrastructure />
        <FutureModules />
        <Roadmap />
        <About />
        <Investors />
        <Referral />
        <DownloadCTA />
      </main>
      <Footer />
    </div>
  </SmoothScroll>
);

function AppRouter() {
  const location = useLocation();
  // OAuth returns land on /app#session_id=... — handle before any route renders.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/verify" element={<VerifyMagic />} />
      <Route element={<RequireAuth />}>
        <Route path="/app" element={<MembersLayout />}>
          <Route index element={<Overview />} />
          <Route path="wallet" element={<Wallet />} />
          <Route path="token" element={<Token />} />
          <Route path="products" element={<Products />} />
          <Route path="rewards" element={<Rewards />} />
          <Route path="referrals" element={<Referrals />} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Route>
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
